import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Inject,
  Injector,
  OnDestroy,
  OnInit
} from '@angular/core';
import {
  FormControl,
  FormGroup
} from '@angular/forms';
import {
  ChartType,
  ILayout,
  ILayoutEntity,
  IChartDialog
} from 'app/charts-dashboard/interfaces';
import { AppStore } from '@iv/store/app.store';
import * as Redux from 'redux';
import { AppState } from '@iv/store/app.reducer';
import { Destroyer } from 'app/common/utils';
import {
  filter,
  takeUntil,
  tap
} from 'rxjs/operators';
import { locale } from './locale';
import { Observable } from 'rxjs';
import { getAllInstruments } from '@iv/store/instruments/instrument.reducer';
import { ChartsDashboardStateService } from '../../state/charts-dashboard-state.service';
import { ChartsDashboardQuery } from '../../state/dashboard';
import { ChartsHttpService } from '../../services/charts-http.service';
import { ChartsCommonService } from '../../services/charts-common.service';
import { ChartsDialogsService } from '../../services/charts-dialogs.service';

@Component({
  selector: 'iv-live-charts-dashboard-control-panel',
  templateUrl: './charts-dashboard-control-panel.component.html',
  styleUrls: ['./charts-dashboard-control-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChartsDashboardControlPanelComponent extends Destroyer implements OnInit, OnDestroy {

  constructor(
    private readonly chartService: ChartsHttpService,
    private readonly chartsCommonService: ChartsCommonService,
    private readonly chartsDialogService: ChartsDialogsService,
    private readonly changeDetectorRef: ChangeDetectorRef,
    private readonly chartsStateService: ChartsDashboardStateService,
    private readonly dashboardQuery: ChartsDashboardQuery,
    @Inject(AppStore) private store: Redux.Store<AppState>,
    @Inject(Injector) private readonly injector: Injector,
  ) {
    super();
  }

  public layouts$: Observable<ILayout[]> = this.chartsStateService.layouts$;
  public allChartTypes$: Observable<ChartType[]> = this.chartsStateService.allChartTypes$;
  public locale = locale;

  public chartDashboardForm = new FormGroup({
    layoutMenuControl: new FormControl(),
    chartSelector: new FormControl()
  });

  public ngOnInit(): void {
    this.dashboardQuery.selectDashboardLayout()
      .pipe(
        tap((layout: ILayoutEntity) => {
          const layoutMenuControl = this.chartDashboardForm.get('layoutMenuControl');

          layoutMenuControl.setValue(layout);
          layout.cardsAmount === 8 ? layoutMenuControl.disable() : layoutMenuControl.enable();
        }),
        takeUntil(this.destroy$)
      )
      .subscribe();
    this.formSubscription();
  }

  public ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  private updateLayout(layoutMenuValue: ILayoutEntity): void {
    if (this.dashboardQuery.getCurrentDashboard.layout.name === layoutMenuValue.name) return;

    this.chartsStateService.selectChartLayout(layoutMenuValue.name);
  }

  private formSubscription(): void {
    const {layoutMenuControl, chartSelector} = this.chartDashboardForm.controls;

    layoutMenuControl.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe((layout: ILayoutEntity) => {
        this.updateLayout(layout);
      });

    chartSelector.valueChanges
      .pipe(
        filter((chartVariant: ChartType) => chartVariant !== null),
        takeUntil(this.destroy$)
      )
      .subscribe((chartVariant: ChartType) => {
        if (chartVariant) {
          this.openAddChartDialog(chartVariant);
          chartSelector.setValue(null);
        }
      });
  }

  private openAddChartDialog(chartVariant: ChartType): void {
    const data: IChartDialog = {
      chartVariant,
      listChartTypes: this.allChartTypes$,
      instruments: getAllInstruments(this.store.getState())
    };

    this.chartsDialogService.createAddChartDialog(this.injector, data);
  }
}
